import { STORE_LOCATION_SPECIFIC_DATA } from "../actions/drivers";

export default (state = {location: null, driversCount: null}, action = {}) => {
  switch (action.type) {
    case STORE_LOCATION_SPECIFIC_DATA:
      return action.payload;
    default:
      return state;
  }
};